export default {
  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'Təmizləmək'
    },
    datepicker: {
      now: 'İndi',
      today: 'Bu gün',
      cancel: 'İmtina',
      clear: 'Təmizləmək',
      confirm: 'OK',
      selectDate: 'Tarixi seçmək',
      selectTime: 'Vaxtı seçmək',
      startDate: 'Başlama tarixi',
      startTime: 'Başlama vaxtı',
      endDate: 'Bitmə tarixi',
      endTime: 'Bitmə vaxtı',
      prevYear: 'Ötən il',
      nextYear: 'Gələn il',
      prevMonth: 'Ötən ay',
      nextMonth: 'Gələn ay',
      year: '',
      month1: 'Yanvar',
      month2: 'Fevral',
      month3: 'Mart',
      month4: 'Aprel',
      month5: 'May',
      month6: 'İyun',
      month7: 'İyul',
      month8: 'Avqust',
      month9: 'Sentyabr',
      month10: 'Oktyabr',
      month11: 'Noyabr',
      month12: 'Dekabr',
      week: 'Həftə',
      weeks: {
        sun: 'B',
        mon: 'B.e',
        tue: 'Ç.a',
        wed: 'Ç',
        thu: 'C.a',
        fri: 'C',
        sat: 'Ş'
      },
      months: {
        jan: 'Yan',
        feb: 'Fev',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'İyun',
        jul: 'İyul',
        aug: 'Avq',
        sep: 'Sen',
        oct: 'Okt',
        nov: 'Noy',
        dec: 'Dek'
      }
    },
    select: {
      loading: 'Yüklənir',
      noMatch: 'Uyğunluq tapılmadı',
      noData: 'Məlumat yoxdur',
      placeholder: 'Seçmək'
    },
    cascader: {
      noMatch: 'Uyğunluq tapılmadı',
      loading: 'Yüklənir',
      placeholder: 'Seçmək',
      noData: 'Məlumat yoxdur'
    },
    pagination: {
      goto: 'Keçid etmək',
      pagesize: ' səhifədə',
      total: 'CƏmi {total}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'Mesaj',
      confirm: 'OK',
      cancel: 'İmtina',
      error: 'Yanlış məlumat'
    },
    upload: {
      deleteTip: 'Silmək üçün [Silmək] seçin',
      delete: 'Silmək',
      preview: 'İlkin baxış',
      continue: 'Davam etmək'
    },
    table: {
      emptyText: 'Məlumat yoxdur',
      confirmFilter: 'Təsdiq edin',
      resetFilter: 'Sıfırlamaq',
      clearFilter: 'Hamısı',
      sumText: 'Məbləğ'
    },
    tree: {
      emptyText: 'Məlumat yoxdur'
    },
    transfer: {
      noMatch: 'Uyğunluq tapılmadı',
      noData: 'Məlumat yoxdur',
      titles: ['Siyahı 1', 'Siyahı 2'],
      filterPlaceholder: 'Açar söz daxil edin',
      noCheckedFormat: '{total} bəndlər',
      hasCheckedFormat: '{checked}/{total} seçilib'
    },
    image: {
      error: 'Xəta baş verdi'
    },
    pageHeader: {
      title: 'Geri'
    },
    popconfirm: {
      confirmButtonText: 'OK',
      cancelButtonText: 'İmtina'
    },
    empty: {
      description: 'Məlumat yoxdur'
    }
  }
}
